// Yamaha ECU hardware code (1A 94) -> part number.
export const YAMAHA_PART_DB = {
  "01594040": "1FD-H591A-11",
  "01712001": "1LB-H591A-00",
  "01811000": "1PA-H591A-00",
  "019D4000": "1WD-H591A-00",
  "019D4001": "1WD-H591A-01",
  "01A54000": "1YD-H591A-00",
  "02520000": "2DP-H591A-00",
  "02520080": "2DP-H591A-20",
  "02523000": "2DS-H591A-00",
  "02763001": "2MS-H591A-01",
  "02794040": "2PV-H591A-00",
  "02794080": "2PV-H591A-10",
  "02818000": "2PH-H591A-00",
  "02818040": "2PH-H591A-10",
  "0281B000": "2PK-H591A-00",
  "028E8000": "2SX-H591A-00",
  "02920000": "2TP-H594A-00",
  "029D4000": "2WD-H591A-00",
  "029D4001": "2WD-H591A-01",
  "05120001": "54P-H591A-01/10",
  "05120002": "54P-H591A-02/11",
  "05120003": "54P-H591A-03/12",
  "05253000": "59C-8591A-01",
  "05253040": "59C-8591A-10",
  "1205C000": "B1L-H591A-00",
  "128A6001": "BRV0-H591A-01 (Fazzio 125 Hybrid)",
  "12060000": "B1P-H591A-00",
  "12064000": "B1T-H594A-00",
  "12064001": "B1T-H594A-01",
  "12068080": "B1X-H591A-20",
  "120A4001": "B2T-H594A-01",
  "120D6000": "B3F-H594A-00",
  "120D6040": "B3F-H594A-10",
  "120D60C0": "B3F-H594A-30",
  "120D6100": "B3F-H594A-40",
  "120DD000": "B3M-H591A-00",
  "120E7000": "B3W-H594A-00",
  "120E7040": "B3W-H594A-10",
  "12108000": "BG7-H591A-00",
  "12126000": "B4V-H594A-00",
  "12126001": "B4V-H594A-01",
  "12154000": "B5D-H594A-00",
  "12154040": "B5D-H594A-10",
  "12154080": "B5D-H594A-20",
  "121540C0": "B5D-H594A-30",
  "12166000": "B5V-H591A-00",
  "12166040": "B5V-H591A-10",
  "12168000": "B5X-H591A-00",
  "12168040": "B5X-H591A-10",
  "12168080": "B5X-H591A-20",
  "12183000": "B63-H594A-00",
  "12183001": "B63-H594A-01",
  "12183040": "B63-H594A-10",
  "12183041": "B63-H594A-11",
  "12183080": "B63-H594A-20",
  "121830C0": "B63-H594A-30",
  "12184001": "B64-H594A-01",
  "12198000": "B6H-H594A-00",
  "12198001": "B6H-H594A-01",
  "12198002": "B6H-H594A-02",
  "12198040": "B6H-H594A-10",
  "12198041": "B6H-H594A-11",
  "121A9000": "B6Y-H594A-01",
  "121A9040": "B6Y-H594A-10",
  "121A9080": "B6Y-H594A-20",
  "121A90C0": "B6Y-H594A-30",
  "121C4000": "B74-H591A-00",
  "121C4041": "B74-H591A-10",
  "12211002": "B8A-H594A-00",
  "12212001": "B8B-H594A-00",
  "12212041": "B8B-H594A-10",
  "12214000": "B8D-H591A-00",
  "12214040": "B8D-H591A-10",
  "12252000": "B9B-H591A-00",
  "12255000": "B9E-H591A-00",
  "12468000": "BAX-H591A-00",
  "12491000": "BBA-H594A-00",
  "124A0000": "BBP-H594A-00",
  "124A0001": "BBP-H594A-01",
  "124A0040": "BBP-H594A-10",
  "124A0041": "BBP-H594A-11",
  "124A0080": "BBP-H594A-20",
  "124A00C0": "BBP-H594A-30",
  "124A3000": "BBS-H591A-00",
  "124A3040": "BBS-H591A-10",
  "124C3000": "BC3-8591A-00",
  "124C3001": "BC3-8591A-01",
  "1251B000": "BDK-H591A-00",
  "12554000": "BED-H591A-00",
  "1255A000": "BEJ-H594A-00",
  "12586001": "BF6-H594A-01",
  "12586041": "BF6-H594A-11",
  "125C6000": "BG6-H591A-00",
  "125C6081": "BG6-H591A-20",
  "12688000": "BJ8-H591A-00 (BJ80)",
  "1269B000": "BJK-K594A-00",
  "1269B040": "BJK-K594A-10",
  "126C6000": "BK6-H591A-00",
  "126D1040": "BKA-H591A-10",
  "126D10C0": "BKA-H591A-30",
  "126E5000": "BKU-H594A-00",
  "12756000": "BMF-H591A-10",
  "12756040": "BMF-H591A-10",
  "127A6000": "BNV-H591A-00",
  "12826000": "BPV-H591A-00",
  "12885000": "BR5-H591A-00",
  "128A6000": "BRV-H594A-00",
  "128C8000": "BS8-H591A-00",
  "128DD000": "BSM-H591A-00",
  "12981000": "BV1-8591A-00",
  "12A09000": "BX9-H591A-00",
  "12A09040": "BX9-H591A-10",
  "12A09080": "BX9-H591A-20",
  "12A48000": "BY8-H591A-00",
};
